import { useQuery } from '@tanstack/react-query';

import { getDiscoveryService } from '../services/discoveryService';
import { useKioskParams } from './useKioskParams';

export function useKioskRegistration(clientName: string) {
  const discoveryService = getDiscoveryService()!;

  const { id: kioskId } = useKioskParams() || {};

  return useQuery({
    staleTime: Infinity,
    enabled: !!kioskId,
    queryKey: ['kiosk-registration', clientName, kioskId],
    queryFn: async () => discoveryService.getKioskRegistration(kioskId!),
  });
}
